import { computed } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import { ENTITY_LIST_QUERY_OPTIONS } from '../constants';

import { queryKeys } from '../queryKeys';

import { pages as pagesRoute } from '@/api/routes/pages';
import apiClient from '@/modules/ApiClient';
import { useAccountsService } from '@/modules/Accounts/services/AccountsService';
import type { PageGroupListItem } from '@/modules/Pages/declarations/pages';
import { normalizePageGroupListItem } from '@/modules/Pages/utils/pagePayload';

export function usePagesListQuery() {
  const accountsService = useAccountsService();
  const accountId = computed(() => accountsService.account?.id ?? '');

  return useQuery({
    queryKey: computed(() => queryKeys.pages.list(accountId.value)),
    queryFn: async () => {
      const { data } = await apiClient.request<{ data: PageGroupListItem[] }>({
        method: 'GET',
        url: pagesRoute,
        pathParams: {
          accountId: accountId.value,
        },
        headers: {
          'x-thn-account-id': accountId.value,
        },
      });

      return (data.data ?? []).map(normalizePageGroupListItem);
    },
    enabled: computed(() => Boolean(accountId.value)),
    ...ENTITY_LIST_QUERY_OPTIONS,
  });
}
